import { render, staticRenderFns } from "./Podcasting20.vue?vue&type=template&id=3ad15eb8&"
import script from "./Podcasting20.vue?vue&type=script&lang=js&"
export * from "./Podcasting20.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports